/* Selva Tierra meridian chart: the twelve classic channels and two midline vessels of Traditional
   Chinese Medicine, plus the seven chakras, drawn on an original front and back figure. Paths are
   simplified, artistic routes for orientation, not anatomical or clinical maps. */
(function () {
  var COLORS = { wood: '#6f8c62', fire: '#b5533c', earth: '#c99146', metal: '#8e877c', water: '#4f6f7a', vessel: '#5b3a24' };
  var ELEMENT_NAMES = { wood: 'Wood', fire: 'Fire', earth: 'Earth', metal: 'Metal', water: 'Water', vessel: 'Extraordinary vessel' };

  // Half silhouette (the viewer's left side, crown to crotch) as cubic segments; mirrored for the full figure.
  var HALF = [[100, 8],
    [89, 8, 81, 16, 81, 29], [81, 38, 83, 46, 87, 51], [89, 55, 92, 57, 93, 59], [93, 63, 92, 67, 90, 70],
    [84, 73, 74, 75, 65, 79], [55, 82, 49, 89, 48, 99], [46, 110, 47, 122, 46, 134], [45, 144, 45, 152, 44, 160],
    [43, 166, 42, 171, 42, 176], [40, 188, 41, 204, 45, 222], [46, 228, 46, 232, 45, 236],
    [43, 244, 41, 254, 42, 263], [43, 272, 50, 277, 54, 271], [56, 264, 57, 252, 57, 240], [57, 236, 57, 232, 57, 228],
    [58, 214, 59, 198, 59, 184], [59, 176, 60, 170, 61, 164], [62, 150, 63, 130, 65, 112], [66, 108, 67, 106, 67, 105],
    [68, 118, 69, 132, 71, 146], [72, 156, 72, 166, 71, 176], [70, 186, 69, 196, 70, 208],
    [70, 226, 72, 250, 76, 272], [78, 284, 79, 294, 80, 302], [80, 308, 81, 316, 80, 324],
    [77, 334, 76, 350, 78, 366], [80, 378, 81, 388, 82, 398], [82, 404, 82, 408, 81, 411],
    [79, 416, 74, 421, 75, 426], [77, 430, 90, 430, 94, 426], [96, 421, 95, 414, 95, 408], [95, 402, 95, 398, 96, 394],
    [98, 380, 98, 358, 97, 340], [97, 332, 97, 328, 97, 324], [97, 316, 98, 310, 98, 304], [99, 284, 100, 250, 100, 214]];

  function silhouette() {
    var d = 'M' + HALF[0].join(' '), i, s, prev;
    for (i = 1; i < HALF.length; i++) d += 'C' + HALF[i].join(' ');
    for (i = HALF.length - 1; i >= 1; i--) {
      s = HALF[i]; prev = HALF[i - 1];
      var px = prev.length === 2 ? prev[0] : prev[4], py = prev.length === 2 ? prev[1] : prev[5];
      d += 'C' + (200 - s[2]) + ' ' + s[3] + ' ' + (200 - s[0]) + ' ' + s[1] + ' ' + (200 - px) + ' ' + py;
    }
    return d + 'Z';
  }
  function mirror(d) { return d.replace(/(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)/g, function (m, x, y) { return (200 - x) + ' ' + y; }); }

  // Channels. front/back: path on the viewer's left half (mirrored for the other side) or center: true.
  var CHANNELS = [
    { id: 'lu', name: 'Lung', pinyin: 'Shou Taiyin Fei Jing', el: 'metal', yin: 'Yin',
      front: 'M71 91C62 96 54 102 52 112L50 160C48 180 46 205 47 230L43 262',
      path: 'From the chest just below the collarbone, along the front of the arm on the thumb side, to the tip of the thumb.',
      assoc: 'Breath, the boundary between inside and outside, and letting go. Metal is the element of autumn, of clarity and of grief honored and released.',
      skin: 'Inner forearm and wrist pieces on the thumb side sit along this line.' },
    { id: 'li', name: 'Large Intestine', pinyin: 'Shou Yangming Da Chang Jing', el: 'metal', yin: 'Yang',
      back: 'M45 266L47 230C46 205 45 190 46 176C47 150 48 125 50 106C54 92 62 84 72 80C80 76 86 70 90 64',
      path: 'From the index finger, up the outer forearm and arm on the thumb side, over the shoulder and neck to beside the nose.',
      assoc: 'Release and clearing what is no longer needed, the partner of the Lung.',
      skin: 'Outer forearm, outer arm and shoulder-cap pieces follow it.' },
    { id: 'st', name: 'Stomach', pinyin: 'Zu Yangming Wei Jing', el: 'earth', yin: 'Yang',
      front: 'M93 31C92 40 91 48 90 54C91 62 92 70 89 80C86 92 84 104 84 112C86 130 90 140 90 160C90 175 88 185 86 196C84 230 84 270 86 300C87 320 86 340 86 360C87 380 88 395 88 406L85 428',
      path: 'From below the eye, down the face and neck, through the chest and belly, down the front of the thigh and shin to the second toe.',
      assoc: 'Nourishment and receiving: taking in what the world offers. Earth is the element of the center, of harvest and of steadiness.',
      skin: 'Front-of-thigh and shin pieces run along it.' },
    { id: 'sp', name: 'Spleen', pinyin: 'Zu Taiyin Pi Jing', el: 'earth', yin: 'Yin',
      front: 'M94 428L95 402C96 380 97 350 97 330C97 300 96 270 94 240C92 220 90 205 87 192C84 175 81 160 80 145C78 125 76 112 73 100',
      path: 'From the big toe, past the inner ankle, up the inner shin and thigh, then along the side of the belly to the chest.',
      assoc: 'Thought, focus and turning food and experience into strength. Associated with feeling grounded and centered.',
      skin: 'Inner calf, inner thigh and side-rib pieces sit along it.' },
    { id: 'ht', name: 'Heart', pinyin: 'Shou Shaoyin Xin Jing', el: 'fire', yin: 'Yin',
      front: 'M66 107C62 115 60 130 60 150L59 166C58 195 57 215 57 232L55 268',
      path: 'From the armpit, down the inner arm on the little-finger side, to the tip of the little finger.',
      assoc: 'In the tradition, the Heart houses the Shen, the spirit. Joy, warmth and connection. Fire is the element of summer and of full expression.',
      skin: 'Inner bicep and pinky-side wrist pieces sit along it.' },
    { id: 'si', name: 'Small Intestine', pinyin: 'Shou Taiyang Xiao Chang Jing', el: 'fire', yin: 'Yang',
      back: 'M56 268L57 232C58 210 59 190 60 168C61 145 62 125 64 110C68 104 76 104 80 98C78 92 74 90 78 84C84 78 88 70 90 62',
      path: 'From the little finger, up the back of the arm on the little-finger side, zigzagging over the shoulder blade, up the neck to the ear.',
      assoc: 'Discernment: sorting what to keep from what to release, the partner of the Heart.',
      skin: 'Back-of-arm and shoulder-blade pieces follow it.' },
    { id: 'bl', name: 'Bladder', pinyin: 'Zu Taiyang Pang Guang Jing', el: 'water', yin: 'Yang',
      back: 'M95 30C95 40 95 55 95 70L95 196C93 210 90 225 88 240L88 300L89 318C88 340 87 360 86 380C85 395 84 402 83 408L78 428M89 74L89 196C88 205 87 212 88 236',
      path: 'The longest channel: from the inner corner of the eye, over the head, down two lines on each side of the spine, down the back of the legs, past the outer ankle to the little toe.',
      assoc: 'Reserves, flow and the strength of the back. Water is the element of winter, of depth and of stillness.',
      skin: 'Pieces running beside the spine, and on the back of the thigh and calf, follow it.' },
    { id: 'ki', name: 'Kidney', pinyin: 'Zu Shaoyin Shen Jing', el: 'water', yin: 'Yin',
      front: 'M97 198L97 130C96 118 93 108 92 96L92 82',
      back: 'M93 416C95 410 96 405 96 398C97 380 97 350 96 330L96 318C97 290 98 255 98 214',
      path: 'From the sole of the foot, around the inner ankle, up the inner back of the leg, then up the belly close to the midline to the collarbone.',
      assoc: 'Essence, willpower and what we inherit from our ancestors. Tied in the tradition to our deepest reserves.',
      skin: 'Inner ankle and low-belly pieces sit along it.' },
    { id: 'pc', name: 'Pericardium', pinyin: 'Shou Jueyin Xin Bao Jing', el: 'fire', yin: 'Yin',
      front: 'M82 106C72 108 63 113 57 121L55 162C55 190 52 210 51 232L49 272',
      path: 'From the chest beside the nipple, down the middle of the inner arm, to the tip of the middle finger.',
      assoc: 'The heart protector: boundaries, emotional safety and opening the heart to others.',
      skin: 'Centered inner-forearm pieces run right along it.' },
    { id: 'tb', name: 'Triple Burner', pinyin: 'Shou Shaoyang San Jiao Jing', el: 'fire', yin: 'Yang',
      back: 'M51 272L51 234C52 210 53 190 53 172C54 150 55 130 57 110C60 96 66 88 76 82C84 76 88 66 89 56',
      path: 'From the ring finger, up the middle of the back of the arm, over the shoulder, around the ear to the outer eyebrow.',
      assoc: 'Harmony and communication between the upper, middle and lower body.',
      skin: 'Centered outer-forearm pieces and behind-the-ear pieces follow it.' },
    { id: 'gb', name: 'Gallbladder', pinyin: 'Zu Shaoyang Dan Jing', el: 'wood', yin: 'Yang',
      front: 'M88 31C84 26 82 22 83 18C80 24 81 32 82 40L84 56C82 64 80 70 76 76C72 100 70 120 70 140C71 160 71 175 70 190C71 220 73 250 77 285C79 305 80 320 79 340C79 360 80 385 81 404L79 426',
      back: 'M82 40L84 56C82 64 80 70 76 76C72 100 70 120 70 140C71 160 71 175 70 190C71 220 73 250 77 285C79 305 80 320 79 340C79 360 80 385 81 404L79 426',
      path: 'From the outer corner of the eye, zigzagging over the side of the head, down the side of the body, the outer thigh and leg, to the fourth toe.',
      assoc: 'Decision and courage. Wood is the element of spring, of growth and of reaching toward the light.',
      skin: 'Outer-thigh, side-body and behind-the-ear pieces follow it.' },
    { id: 'lr', name: 'Liver', pinyin: 'Zu Jueyin Gan Jing', el: 'wood', yin: 'Yin',
      front: 'M92 428L91 414C92 405 93 400 94 396C95 370 95 340 96 320C97 290 98 260 97 230C96 215 94 205 92 198C90 180 87 160 84 128',
      path: 'From the big toe, over the top of the foot, up the inner leg and thigh, to the lower ribs below the chest.',
      assoc: 'Vision, planning and a smooth flow through life. Associated with growth, like a forest reaching up.',
      skin: 'Top-of-foot, inner-leg and lower-rib pieces sit along it.' },
    { id: 'ren', name: 'Conception Vessel', pinyin: 'Ren Mai', el: 'vessel', yin: 'Yin',
      front: 'M100 214L100 46', center: true,
      path: 'Straight up the front midline of the body, from the pelvic floor to the lower lip.',
      assoc: 'Called the sea of yin: nurturing, receptivity and beginnings.',
      skin: 'Sternum and belly-line pieces sit right on it.' },
    { id: 'du', name: 'Governing Vessel', pinyin: 'Du Mai', el: 'vessel', yin: 'Yang',
      back: 'M100 214L100 12', center: true,
      path: 'Straight up the spine from the tailbone, over the crown of the head, to the upper lip.',
      assoc: 'Called the sea of yang: strength, uprightness and drive.',
      skin: 'Spine pieces run right along it.' }
  ];

  var CHAKRAS = [
    { name: 'Crown', sk: 'Sahasrara', y: 7, c: '#7d6a8f', t: 'Connection to something larger than yourself.' },
    { name: 'Third eye', sk: 'Ajna', y: 26, c: '#4e5c86', t: 'Intuition and inner vision.' },
    { name: 'Throat', sk: 'Vishuddha', y: 64, c: '#5f8597', t: 'Expression and speaking your truth.' },
    { name: 'Heart', sk: 'Anahata', y: 108, c: '#7f9a6c', t: 'Love, compassion and openness.' },
    { name: 'Solar plexus', sk: 'Manipura', y: 140, c: '#d9b45a', t: 'Will, confidence and personal power.' },
    { name: 'Sacral', sk: 'Svadhisthana', y: 174, c: '#c9773f', t: 'Creativity, pleasure and flow.' },
    { name: 'Root', sk: 'Muladhara', y: 206, c: '#9b3b2a', t: 'Grounding, safety and belonging.' }
  ];

  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init(root) {
    var svg = root.querySelector('.meridians__svg');
    var card = root.querySelector('[data-meridians-card]');
    var list = root.querySelector('.meridians__list');
    var sil = silhouette();
    var html = '';

    [['front', 0], ['back', 220]].forEach(function (v) {
      html += '<g transform="translate(' + v[1] + ' 0)">';
      html += '<path d="' + sil + '" class="meridians__body"/>';
      CHANNELS.forEach(function (c) {
        var d = c[v[0]]; if (!d) return;
        var both = c.center ? d : d + ' ' + mirror(d);
        html += '<g class="meridians__ch" data-ch="' + c.id + '" data-el="' + c.el + '" style="--c:' + COLORS[c.el] + '" tabindex="0" role="button" aria-label="' + esc(c.name) + ' channel">' +
          '<path class="meridians__hit" d="' + both + '"/><path class="meridians__line' + (c.center ? ' is-vessel' : '') + '" d="' + both + '"/></g>';
      });
      if (v[0] === 'front') {
        CHAKRAS.forEach(function (k, i) {
          html += '<g class="meridians__chakra" data-chakra="' + i + '" tabindex="0" role="button" aria-label="' + esc(k.name) + ' chakra">' +
            '<circle cx="100" cy="' + k.y + '" r="6.5" fill="' + k.c + '"/><circle cx="100" cy="' + k.y + '" r="2.2" fill="#fffaf3"/></g>';
        });
      }
      html += '<text x="100" y="452" text-anchor="middle">' + (v[0] === 'front' ? 'Front' : 'Back') + '</text></g>';
    });
    svg.innerHTML = html;

    list.innerHTML = CHANNELS.map(function (c) {
      return '<li><button type="button" data-pick="' + c.id + '" style="--c:' + COLORS[c.el] + '"><i></i>' + esc(c.name) + '</button></li>';
    }).join('');

    function show(id) {
      var c = CHANNELS.filter(function (x) { return x.id === id; })[0]; if (!c) return;
      root.classList.add('is-focus');
      root.querySelectorAll('.meridians__ch').forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-ch') === id); });
      root.querySelectorAll('[data-pick]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-pick') === id); });
      card.innerHTML = '<p class="meridians__card-eyebrow"><i style="--c:' + COLORS[c.el] + '"></i>' + esc(ELEMENT_NAMES[c.el]) + ' · ' + esc(c.yin) + '</p>' +
        '<h3 class="meridians__card-title">' + esc(c.name) + '</h3><p class="meridians__card-pinyin">' + esc(c.pinyin) + '</p>' +
        '<h4>The path</h4><p>' + esc(c.path) + '</p><h4>Traditionally associated with</h4><p>' + esc(c.assoc) + '</p>' +
        '<h4>On the skin</h4><p>' + esc(c.skin) + '</p>';
      fresh();
    }
    function showChakra(i) {
      var k = CHAKRAS[i];
      root.classList.remove('is-focus');
      root.querySelectorAll('.meridians__ch, [data-pick]').forEach(function (g) { g.classList.remove('is-on'); });
      card.innerHTML = '<p class="meridians__card-eyebrow"><i style="--c:' + k.c + '"></i>Chakra · yogic tradition of India</p>' +
        '<h3 class="meridians__card-title">' + esc(k.name) + '</h3><p class="meridians__card-pinyin">' + esc(k.sk) + '</p>' +
        '<h4>Traditionally associated with</h4><p>' + esc(k.t) + '</p>' +
        '<h4>On the skin</h4><p>The seven chakras sit along the front midline, from the base of the spine to the crown. Sternum, belly and spine pieces can be placed in line with them.</p>';
      fresh();
    }
    function fresh() { card.classList.remove('is-fresh'); void card.offsetWidth; card.classList.add('is-fresh'); if (window.matchMedia('(max-width: 989px)').matches) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }

    svg.addEventListener('click', function (ev) {
      var g = ev.target.closest('.meridians__ch'); if (g) return show(g.getAttribute('data-ch'));
      var k = ev.target.closest('.meridians__chakra'); if (k) return showChakra(+k.getAttribute('data-chakra'));
    });
    svg.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var g = ev.target.closest('.meridians__ch'), k = ev.target.closest('.meridians__chakra');
      if (g || k) { ev.preventDefault(); if (g) show(g.getAttribute('data-ch')); else showChakra(+k.getAttribute('data-chakra')); }
    });
    list.addEventListener('click', function (ev) { var b = ev.target.closest('[data-pick]'); if (b) show(b.getAttribute('data-pick')); });

    root.querySelectorAll('[data-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter');
        root.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        root.classList.remove('is-focus');
        root.setAttribute('data-filter', f);
        root.querySelectorAll('.meridians__ch').forEach(function (g) {
          var el = g.getAttribute('data-el'); g.classList.toggle('is-dim', f !== 'all' && f !== 'chakra' && f !== el);
          g.classList.remove('is-on');
        });
        root.querySelectorAll('[data-pick]').forEach(function (x) { x.classList.remove('is-on'); });
      });
    });
  }

  function boot() { document.querySelectorAll('[data-meridians-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
